import React from 'react';
import { Card, CardBody, CardHeader, Input } from '../components/ui';
import { listCompanies, listProfiles } from '../lib/firestore';
import { formatPersonName } from '../lib/names';
import type { Company, UserProfile } from '../lib/types';

export default function DirectoryPage() {
  const [companies, setCompanies] = React.useState<Company[]>([]);
  const [profiles, setProfiles] = React.useState<UserProfile[]>([]);
  const [q, setQ] = React.useState('');

  React.useEffect(() => {
    listCompanies().then(setCompanies).catch(() => setCompanies([]));
    listProfiles().then(setProfiles).catch(() => setProfiles([]));
  }, []);

  const companyById = React.useMemo(() => {
    const m: Record<string, Company> = {};
    for (const c of companies) m[c.id] = c;
    return m;
  }, [companies]);

  const filteredProfiles = profiles.filter((p) => {
    const c = companyById[p.companyId];
    const hay = `${p.displayName} ${formatPersonName(p.displayName)} ${p.title ?? ''} ${c?.name ?? ''} ${p.roleType}`.toLowerCase();
    return hay.includes(q.trim().toLowerCase());
  });

  return (
    <div className="grid grid-cols-1 gap-4">
      <Card>
        <CardHeader title="People" subtitle="Profiles by company" />
        <CardBody className="space-y-3">
          <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search name, title, company" />
          <div className="overflow-hidden rounded-2xl border border-zinc-200">
            <div className="grid grid-cols-12 gap-2 bg-zinc-50 px-3 py-2 text-xs font-semibold text-zinc-700">
              <div className="col-span-5">Name</div>
              <div className="col-span-4">Company</div>
              <div className="col-span-3">Type</div>
            </div>
            <div>
              {filteredProfiles.map((p) => {
                const c = companyById[p.companyId];
                return (
                  <div key={p.id} className="grid grid-cols-12 gap-2 border-t border-zinc-200 px-3 py-2 text-sm">
                    <div className="col-span-5">
                      <div className="font-semibold">{formatPersonName(p.displayName) || p.displayName}</div>
                      {p.title ? <div className="text-xs text-zinc-600">{p.title}</div> : null}
                    </div>
                    <div className="col-span-4">{c?.name ?? 'Unknown'}</div>
                    <div className="col-span-3">
                      <span className="rounded-full border border-zinc-200 px-2 py-1 text-xs">{c?.type ?? 'n/a'}</span>
                    </div>
                  </div>
                );
              })}
              {filteredProfiles.length === 0 ? <div className="p-3 text-sm text-zinc-600">No matches</div> : null}
            </div>
          </div>
        </CardBody>
      </Card>
    </div>
  );
}
